import {Text} from '../texts'
import {StateChanges, Actions} from './stateChanges'
import _ from 'lodash'

function textToSave (text) {
  // firebase doesn't allow undefined, so make sure it's null instead
  return text ? {
    name: text.name || null,
    keys: text.keys || null
  } : null
}

function saveToText (save) {
  return new Text(save.keys, save.name)
}

function getCurrentExperimentData (state) {
  return {
    text: textToSave(state.testText),
    classes: state.classes.map(classData => textToSave(classData)),
    featureSettings: state.featureSettings,
    removedFeatures: state.removedFeatures,
    chunking: 'DEFAULT',
    experimentName: state.experimentName
  }
}

function gtag () { window.dataLayer.push(arguments) }

function loadExperimentData (store, savedExperiment) {
  store.commit(StateChanges.RESET_EXPERIMENT, {'preparing_to_load': true})
  gtag('config', 'UA-103843509-5', {'page_path': 'load-experiment'})
  store.commit(StateChanges.SET_EXPERIMENT_NAME, savedExperiment.experimentName)
  savedExperiment.classes.forEach(classData => store.commit(StateChanges.ADD_CLASS, saveToText(classData)))
  if (savedExperiment.text) {
    store.commit(StateChanges.SET_TEST_TEXT, saveToText(savedExperiment.text))
  }
  store.commit(StateChanges.SET_FEATURE_SETS, savedExperiment.featureSettings)
  // firebase doesn't save anything without values, so if there are no removedFeatures, it will be missing
  if (savedExperiment.removedFeatures) {
    store.commit(StateChanges.SET_REMOVED_FEATURES, Object.assign(
      // create the default empty lists
      _.fromPairs(Object.keys(store.state.featureSettings).map(featureSetName => [featureSetName, []])),
      // merge in any values that were saved
      savedExperiment.removedFeatures
    ))
  }
  if (savedExperiment.classes.length >= 2) {
    store.dispatch(Actions.RUN_EXTRACT_FEATURES)
    store.dispatch(Actions.RUN_CV)
    if (savedExperiment.text !== null) {
      store.dispatch((Actions.RUN_CLASSIFICATION))
    }
  }
}

export default {
  textToSave,
  saveToText,
  getCurrentExperimentData,
  loadExperimentData
}



// WEBPACK FOOTER //
// ./src/store/savedExperimentUtils.js